import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { pxToRem } from "../../../utils/styles/size";

const SettingsSidebarItem = ({
  changeItem,
  currentIndex,
  section,
  index,
}: {
  changeItem: (index: number) => void;
  currentIndex: number;
  section: { tab: string; content: React.ReactNode };
  index: number;
}) => {
  return (
    <Flex
      bg={currentIndex === index ? "rgba(255, 255, 255, 0.08)" : "transparent"}
      onClick={() => changeItem(index)}
      borderRadius={pxToRem(5)}
      textStyle={"body1"}
      fontWeight={400}
      lineHeight={"150%"}
      padding={"8px 10px"}
      color={"white"}
      cursor={"pointer"}
      alignItems={"center"}
      gap={pxToRem(10)}
      _hover={{ bg: "rgba(255, 255, 255, 0.08)" }}
      key={index}
    >
      <Text>{section.tab}</Text>
    </Flex>
  );
};

export default SettingsSidebarItem;
